document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".has-dropdown");
  const hoverCapable = window.matchMedia("(hover: hover)").matches;

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector(":scope > .nav-dropdown-toggle");
    const panel = dropdown.querySelector(":scope > .nav-dropdown");

    if (!toggle || !panel) return;

    let cleanup = null;

    // -----------------------------
    // CUSTOM POSITIONING (replaces Floating UI)
    // -----------------------------
    function position() {
      const rect = dropdown.getBoundingClientRect();

      panel.style.position = "absolute";
      panel.style.left = rect.left + "px";
      panel.style.top = rect.bottom + "px"; // offset(0)
    }

    function openPanel() {
      if (panel.classList.contains("open") || panel.classList.contains("opening")) return;

      panel.classList.add("opening");

      requestAnimationFrame(() => {
        panel.classList.add("open");
        toggle.setAttribute("aria-expanded", "true"); // ← ADD THIS
      });

      panel.addEventListener(
        "transitionend",
        () => {
          panel.classList.remove("opening");
        },
        { once: true }
      );
    }

    function closePanel() {
      if (!panel.classList.contains("open") && !panel.classList.contains("opening")) return;

      // Close ALL nested dropdowns inside this one
      const nestedPanels = panel.querySelectorAll(".nav-dropdown.open");

      nestedPanels.forEach((nested) => {
        nested.classList.add("closing");
        nested.classList.remove("open");

        // Close ALL nested dropdowns inside this one
        const nestedPanels = panel.querySelectorAll(".nav-dropdown");

        nestedPanels.forEach((nested) => {
          nested.classList.remove("open", "opening", "closing");

          const nestedToggle = nested.parentElement.querySelector(":scope > .nav-dropdown-toggle");
          nestedToggle?.setAttribute("aria-expanded", "false");
        });
      });

      // Close this panel
      panel.classList.add("closing");
      panel.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");

      panel.addEventListener(
        "transitionend",
        () => {
          panel.classList.remove("closing");
          if (cleanup) {
            cleanup();
            cleanup = null;
          }
        },
        { once: true }
      );
    }

    // CLICK (works on all devices)
    toggle.addEventListener("click", (e) => {
      e.stopPropagation();

      const isOpen = panel.classList.contains("open");

      // Close siblings
      const siblings = dropdown.parentElement.querySelectorAll(":scope > .has-dropdown");

      siblings.forEach((sibling) => {
        if (sibling === dropdown) return;

        const otherPanel = sibling.querySelector(":scope > .nav-dropdown");
        const otherToggle = sibling.querySelector(":scope > .nav-dropdown-toggle");

        if (otherPanel && otherPanel.classList.contains("open")) {
          otherPanel.classList.add("closing");
          otherPanel.classList.remove("open");
          otherToggle?.setAttribute("aria-expanded", "false"); // ← sibling toggle update

          otherPanel.addEventListener(
            "transitionend",
            () => {
              otherPanel.classList.remove("closing");
            },
            { once: true }
          );
        }
      });

      if (!isOpen) openPanel();
      else closePanel();
    });

    // HOVER (only on hover-capable devices)
    if (hoverCapable) {
      dropdown.addEventListener("mouseenter", () => {
        openPanel();
      });

      dropdown.addEventListener("mouseleave", (e) => {
        const rt = e.relatedTarget;

        // Treat the panel as part of the hover zone
        if (!dropdown.contains(rt) && !panel.contains(rt)) {
          closePanel();
        }
      });
    }
  });

  // OUTSIDE CLICK
  document.addEventListener("click", () => {
    document.querySelectorAll(".nav-dropdown.open").forEach((panel) => {
      const toggle = panel.parentElement.querySelector(":scope > .nav-dropdown-toggle");

      panel.classList.add("closing");
      panel.classList.remove("open");
      toggle?.setAttribute("aria-expanded", "false"); // ← outside click update

      panel.addEventListener(
        "transitionend",
        () => {
          panel.classList.remove("closing");
        },
        { once: true }
      );
    });
  });
});
